import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AwardsService } from '../services';
import { awardsKeys } from '../queryKeys';

export const useUploadMembershipsCsv = (cycleId, options = {}) => {
  const { onSuccess, onError } = options;
  const queryClient = useQueryClient();

  return useMutation({
    // Partial success is the normal outcome and is rendered in the dialog, so
    // nothing here should reach the global toaster.
    meta: { skipGlobalErrorToaster: true },
    mutationFn: (file) => AwardsService.uploadMembershipsCsv(cycleId, file),
    onSuccess: (result) => {
      queryClient.invalidateQueries({
        queryKey: awardsKeys.membershipsPrefix(cycleId),
      });
      onSuccess?.(result);
    },
    onError,
  });
};
